import { initializeApp } from 'firebase/app'
import { connectAuthEmulator, getAuth } from 'firebase/auth'
import { connectFirestoreEmulator, initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore'
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions'
import { connectStorageEmulator, getStorage } from 'firebase/storage'

const env = import.meta.env
export const USE_EMULATORS = env.VITE_USE_EMULATORS === 'true'
export const PROJECT_ID = (env.VITE_FIREBASE_PROJECT_ID as string) || (USE_EMULATORS ? 'demo-sonder' : 'sonder-portal')

export const app = initializeApp({
  apiKey: (env.VITE_FIREBASE_API_KEY as string) || (USE_EMULATORS ? 'demo-key' : ''),
  authDomain: (env.VITE_FIREBASE_AUTH_DOMAIN as string) || `${PROJECT_ID}.firebaseapp.com`,
  projectId: PROJECT_ID,
  storageBucket: (env.VITE_FIREBASE_STORAGE_BUCKET as string) || `${PROJECT_ID}.firebasestorage.app`,
  messagingSenderId: (env.VITE_FIREBASE_MESSAGING_SENDER_ID as string) || '',
  appId: (env.VITE_FIREBASE_APP_ID as string) || '',
})

export const auth = getAuth(app)
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
})
export const functions = getFunctions(app, 'us-east1')
export const storage = getStorage(app)

if (USE_EMULATORS) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true })
  connectFirestoreEmulator(db, '127.0.0.1', 8080)
  connectFunctionsEmulator(functions, '127.0.0.1', 5001)
  connectStorageEmulator(storage, '127.0.0.1', 9199)
}
